module.exports = __webpack_public_path__ + "9f0c65d6808b7852a4fe065988cb2075.svg";